import Cookies from 'js-cookie';
import { convertToDate } from './dates';

const TOKEN_PREFIX = 'midroog_cms';

const APP_TOKEN = `${TOKEN_PREFIX}_token`;
const APP_REFRESH = `${TOKEN_PREFIX}_token_refresh`;
const APP_EXPIRE = `${TOKEN_PREFIX}_token_date`;


const getCookies = (name: string) => {;
  return Cookies.get(name)
};
const setCookies = (name: string, data = '', expires = '') => {

  if (data) {
    Cookies.set(name, data, { expires: expires ? convertToDate(expires) : undefined, secure: true, sameSite: 'lax' })
  } else {
    Cookies.remove(name)
  }
};

interface TokenOptions {
  token: string;
  refreshToken: string;
  expires: string;
}

export const updateAuthTokens = ({
  token,
  expires,
  refreshToken,
}: Partial<TokenOptions> = {}) => {

  setCookies(APP_TOKEN, token, expires);
  setCookies(APP_REFRESH, refreshToken, expires);
  setCookies(APP_EXPIRE, expires, expires);
};
export const getAuthTokens = () => {
  return {
    token: getCookies(APP_TOKEN),
    refreshToken: getCookies(APP_REFRESH),
    expires: getCookies(APP_EXPIRE),
  };
};
